import styled from "styled-components";

// Estilos da aba "Pré-seleção de Projetos" da seletiva.

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

// Cada lista da aba: os já selecionados, acima, e os candidatos, abaixo.
export const Block = styled.div`
  width: 100%;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
  flex-wrap: wrap;
`;

export const Info = styled.p`
  flex: 1;
  min-width: 240px;
  color: ${({ theme }) => theme.colors.neutral.gray7};
  ${({ theme }) => theme.font.body.sm}
`;

export const Empty = styled.div`
  padding: 40px;
  text-align: center;
  color: ${({ theme }) => theme.colors.neutral.gray6};
`;
